<template>
  <div
    class="col-sm-12 p-0 m-0 mx-auto index-root"
    :class="$route.path === '/iframeURL' ? '' : 'col-lg-4'"
  >
    <NavBar v-if="
      !$route.path.includes('rule') &&
      $route.path !== '/home' &&
      $route.path !== '/' &&
      $route.path !== '/auth/login' &&
      $route.path !== '/auth/register' &&
      $route.path !== '/iframeURL'
    " />
    <router-view
      :class="[
        $route.path.includes('login') ? '' : 'middle-container',
        'index-scroll-main',
        $route.path === '/iframeURL' ? 'iframe-route-scroll' : '',
      ]"
      class="position-relative"
    ></router-view>
    <Footer
      v-if="!$route.path.includes('rule') && !$route.path.includes('live-score') && !$route.path.includes('football-result') && $route.path !== '/iframeURL'"
    />
    <!-- <div class="social-contacts" id="social-contacts">
            <div
                style="position: relative"
                class="cart-container"
                v-if="
                    $route.path.includes('maung-fb') ||
                    $route.path.includes('body-fb')
                "
                @click="openModalVoucher()"
            >
                <div>
                    <i class="ni ni-cart mb-2"></i>
                </div>
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('2d')"
                    >{{ this.$store.state.twod_slip_data.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('fb')"
                    >{{ this.$store.state.fb_order.fb_matches.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-else-if="$route.path.includes('3d')"
                    >{{ this.$store.state.threed_slip_data.length }}</span
                >
            </div>
        </div> -->

    <van-overlay :show="$store.state.isLoading">
      <div
        class="wrapper d-flex h-100vh"
        style="background: rgba(0, 0, 0, 0.8);"
      >
        <div class="loader my-auto mx-auto">

        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="showPopup"
      @click="showPopup = false"
    >
      <div
        class="wrapper col-lg-4 col-md-12 mx-auto d-flex h-100vh"
        @click.stop
      >
        <div
          class="mx-auto my-auto pt-4 px-4 pb-4"
          style="background: rgba(0, 0, 0, 0.8); border-radius: 7px;"
        >
          <!-- <img v-for="(welcome, index) in websiteInfo.welcome_banners" :key="index" :src="'https://yy24gld.sgp1.cdn.digitaloceanspaces.com/luckywin/banners/' + welcome.url" class="mx-auto my-auto" alt="" style="width: 100%; border-radius: 5px;"> -->
          <b-carousel
            id="carousel-1"
            :interval="3000"
            controls
            fade
            style="width: 100%; height: 100%"
          >
            <!-- <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/kob/banners/Viber%20error.avif"
            ></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/kob/banners/vbc.avif"
            ></b-carousel-slide> -->

            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/kob/banners/w1.avif"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/kob/banners/w2.avif"></b-carousel-slide>
            <!-- <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/spin888/cards/SPINIX%20WELCOME12.webp"
            ></b-carousel-slide> -->
          </b-carousel>

          <!-- <video style="border-radius: 5px;" class="d-flex" width="100%" height="auto" autoplay loop muted>
                  <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0512ca93-7a5f-40cd-a989-8f5f3b21a600/public" type="video/mp4" />
                  Your browser does not support the video tag.
                </video> -->



          <div class="mt-3 d-flex flex-column">
            <div class="mx-auto mb-3">
              <div class="d-flex">
                <input
                  type="checkbox"
                  v-model="isHideForToday"
                  class="mb-1 mr-2 p-0 m-0"
                />
                <h3 class="text-white text-center p-0 m-0">Hide For Today</h3>
              </div>
            </div>

            <button
              class="btn btn-primary btn-block w-25 mx-auto text-uppercase"
              style="background: linear-gradient(135deg, #0c0a09 0%, #92400e 50%, #ca8a04 100%) !important"
              @click="closePopup()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </van-overlay>

    <div style="position: fixed; bottom: 70px; right: 10px">
      <div
        class="wave"
        style="position: relative"
      >
        <div
          class="contact"
          @click="showContact = !showContact"
          style="
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: linear-gradient(135deg, #FFFCE0 0%, #F9F38D 30%, #D6B800 60%, #FFF2A8 100%);
                  position: relative;
                "
        >
          <img
            src="https://storage.googleapis.com/spacetech2/general/headphones.png"
            style="width: 40px; height: 40px"
            alt=""
          />
        </div>
        <div
          class="contacts-container"
          :class="{ show: showContact }"
        >
        
          <div style="display: flex; flex-direction: column; gap: 10px">
            <a
              href="https://www.facebook.com/share/186HRE4fuL/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="messenger-icon-tile">
                <img
                  style="width: 3.5rem; height: 3.5rem;"
                  class="contact-float-icon contact-float-icon--messenger"
                  src="https://storage.googleapis.com/spacetech2/melonzeed/messenger.png"
                  alt="Messenger"
                />
              </span>
            </a>
            <a
              href="https://t.me/kob888_bot"
              target="_blank"
            >
              <img
                style="width: 3.5rem; height: 3.5rem"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_telegram.png"
                alt=""
              />
            </a>
            <a href="https://viber.kob888.com/">
              <!-- <a href="#"> -->
              <img
                style="width: 3.5rem; height: 3.5rem;"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_viber.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- <div>
      <FloatIcon />
    </div> -->

    <van-overlay :show="isLuckyWheel">
      <div
        class="wrapper col-8"
        @click.stop
      >
        <LuckyWheel />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import LuckyWheel from '../frontend/components/LuckyWheel.vue';
import { attachIosKeyboardScrollFix } from '@/libs/resetAppScroll';

export default {
  components: {
    LuckyWheel,
  },
  data() {
    return {
      isLuckyWheel: false,
      isHideForToday: false,
      showPopup: false,
      websiteInfo: {},
      popUpLink: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/2025-03-07%205.36.20%E2%80%AFPM.jpg',
      showContact: true,
      interval: null,
      /** teardown for iOS keyboard / visualViewport scroll repair */
      removeIosKeyboardScrollFix: null,
    };
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    this.checkPopupStatus();
    await this.fetchWebsiteData();
    this.removeIosKeyboardScrollFix = attachIosKeyboardScrollFix();
    // this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    if (typeof this.removeIosKeyboardScrollFix === 'function') {
      this.removeIosKeyboardScrollFix();
      this.removeIosKeyboardScrollFix = null;
    }
  },
  computed: {
    ...mapGetters(['getFBOrder']),
  },

  methods: {
    testing() {
      this.isLuckyWheel = true;
      console.log('testing');
    },
    closePopup() {
      this.showPopup = false;
      const today = new Date().toISOString().split('T')[0];
      if (this.isHideForToday)
        localStorage.setItem('popupDismissedDate', today);
    },
    checkPopupStatus() {
      const today = new Date().toISOString().split('T')[0];
      const lastDismissedDate = localStorage.getItem('popupDismissedDate');
      if (lastDismissedDate !== today) {
        this.showPopup = true;
      }
      // if(today === '2025-02-07'){
      //   this.popUpLink = 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/2025-02-07%208.13.41%E2%80%AFPM.jpg';
      // } else {
      //   this.popUpLink = 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/welcome.jpg'
      // }
    },

    ...mapMutations(['setWholeFBMatches']),
    ...mapActions(['fetchUser']),
    closeModalOutside(event) {
      if (event.target.classList.contains('modal')) {
        this.$router.go();
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data[0];
        if (
          res.data.data[0].androidVersion !== this.$store.state.androidVersion
        ) {
          $('#version').modal('show');
        }
      } catch (error) {
        console.log(error);
      }
    },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError =
          this.$store.state.language === 'en'
            ? 'Please select some teams!'
            : 'အသင်းတစ်ချို့ ရွေးပေးပါ။';
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        if (!this.$store.state.betAmount) {
          $('#amount').modal('show');
        } else {
          for (let i = 0; i < matches.length; i += 1) {
            matches[i].bet_amount = this.$store.state.betAmount;
          }
          this.setWholeFBMatches(matches);
          $('#mobile-voucher').modal('show');
        }
      }
    },

    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === 'en'
            ? 'Go Back'
            : 'နောက်သို့ပြန်သွားမည်။',
      }).then(() => {
        // on close
      });
    },
  },
};
</script>
<style scoped>
.hello-world {
  background-image: linear-gradient(0deg,
      #fec8ba,
      #fedcd0 35%,
      #fef0e6) !important;
}


/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border: 4px solid #0000;
  border-radius: 50%;
  border-color: #ccc #0000;
  animation: l16 1s infinite linear;
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;
  margin: 2px;
  border: inherit;
  border-radius: 50%;
}

.loader::before {
  border-color: #f03355 #0000;
  animation: inherit;
  animation-duration: .5s;
  animation-direction: reverse;
}

.loader::after {
  margin: 8px;
}

@keyframes l16 {
  100% {
    transform: rotate(1turn)
  }
}


.active-contact {
  transform: translate(0);
  transition: all 1s ease-in-out;
}

.box-contact .open-contact {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -12px;
  margin: auto;
}

.box-contact a img {
  width: 40px;
}

.box-contact {
  position: fixed;
  top: 60%;
  right: 0;
  border-radius: 12px 0 0 12px !important;
  background: linear-gradient(180deg,
      rgba(62, 62, 62, 0.5411764706) 0%,
      rgba(10, 10, 10, 0.5725490196) 100%);
  padding: 1rem 0.5rem 1rem 1.3rem;
  transform: translate(0);
  animation: slide 2s ease-in;
  z-index: 10;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.4) !important;
}

.floating {
  position: fixed;
  width: 90px;
  z-index: 1;
  animation: floating 20s infinite;
  bottom: 130px;
  right: 0%;
}

#closeButton {
  border: none;
  background: none;
  position: absolute;
  left: -15px;
  font-size: 20px;
  font-weight: bold;
  color: #b7b7b7;
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(-20px);
  }

  100% {
    transform: translatey(0px);
  }
}

.cart-number {
  top: -2px !important;
  left: -2px !important;
}

.cart-number {
  position: absolute;
  top: -3px;
  left: -3px;
  text-align: center;
}

/* Flex shell: scroll lives here so content works with html/body overflow:hidden */
.index-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;
  position: relative;
  overflow: hidden;
}

/* .index-scroll-main + .middle-container: global rules in src/scss/style.scss (scoped CSS here does not apply to router-view child roots) */
@media (max-width: 768px) {
  .cart-container {
    font-size: 30px !important;
  }

  .social-contacts div {
    width: 60px !important;
    height: 60px !important;
    margin-top: 15px;
  }

  #social-contacts .badge-circle.badge-md {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  .cart-container {
    visibility: visible;
    font-size: 16px;
  }
}


.messenger-icon-tile {
  position: relative;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 0.75rem;
  display: block;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.messenger-icon-tile::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* Wide solid white center — nearly full tile; thin outer ring shows icon */
  width: 90%;
  height: 90%;
  background: #ffffff;
  border-radius: 50%;
  z-index: 0;
  pointer-events: none;
}

.contact-float-icon--messenger {
  position: relative;
  z-index: 1;
  box-shadow: none;
}

.contacts-container {
  position: absolute;
  bottom: 110%;
  left: 25%;
  opacity: 0;
  pointer-events: none;
  transform: translateY(20px) translateX(-25%);
  transition: all 0.1s ease-in-out;
}

.contacts-container.show {
  opacity: 1;
  pointer-events: all;
  transform: translateX(-25%) translateY(-10px);
}

.contact {
  animation: wave 2s linear infinite;
}

@keyframes wave {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}
</style>
